import { useNavigate } from 'react-router-dom';

import Route from '@/config/routes/types';
import LandingBrandLogoIcon from '@/shared/components/icons/landing-brand-logo-icon';

export const LandingLayoutHeaderBrand = () => {
  const navigate = useNavigate();

  return (
    <div
      className="static mx-auto flex flex-col items-center cursor-pointer sm:absolute sm:top-8 sm:inset-x-0"
      onClick={() => navigate(Route.ROOT)}
    >
      <div className="w-20 sm:w-24 aspect-[120/36]">
        <LandingBrandLogoIcon />
      </div>
      <span className="-mt-0.5 sm:-mt-1 text-[9px] sm:text-[10px] font-mono tracking-[0.2em] sm:tracking-[0.25em] uppercase text-mountain-mist">
        by Tanglius
      </span>
    </div>
  );
};
